module.exports = __webpack_public_path__ + "img/salut-a-toi.png";